import { Component, ChangeDetectionStrategy, effect, EventEmitter, inject, Input, Output, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { Store } from '@ngrx/store';

import { selectSelectedWorkSpace, selectUiState } from '../../../../store/app.selectors';
import { MessagingEnvironmentService } from '../../../../core/services/messaging-environment.service';
import { BaseComponent } from '../../../shared/components/base/base.component';
import { uiInitialState } from '../../../shared/store/ui.reducer';
import { IWorkspace } from '../../interfaces/IWorkspace';
import { ResizeService } from '../../services/resize.service';
import { MessagingTranslationService } from '../../services/translations.service';
import { AppStateWithChat } from '../../store/chat.reducer';

@Component({
  selector: 'ngx-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LayoutComponent extends BaseComponent {
  @Output() settingsEvent = new EventEmitter<boolean>();
  @Output() orderIdEvent = new EventEmitter<string>();
  @Input() phoneNumber: string;

  private store = inject(Store<AppStateWithChat>);
  private env = inject(MessagingEnvironmentService);
  public translationService = inject(MessagingTranslationService);
  public resizeService = inject(ResizeService);

  ui = toSignal(this.store.select(selectUiState), { initialValue: uiInitialState });
  selectedWorkSpace = toSignal(this.store.select(selectSelectedWorkSpace), {
    initialValue: null as IWorkspace | null,
  });

  isLoadingNewWorkspace = signal(false);
  messagingIconUrl = this.env.env.assetsNgxMessaging + '/images/icon.png';

  constructor() {
    super();
    effect((onCleanup) => {
      this.selectedWorkSpace();
      this.isLoadingNewWorkspace.set(true);
      const timeoutId = setTimeout(() => this.isLoadingNewWorkspace.set(false), 500);
      onCleanup(() => clearTimeout(timeoutId));
    });
  }

  emitOrderIdEvent(event: string): void {
    this.orderIdEvent.emit(event);
  }

  goSettings(): void {
    this.settingsEvent.emit(true);
  }

  onResizeStart(event: MouseEvent): void {
    this.resizeService.startDrag(event);
  }
}
